import { CustomFilterField, CustomFilterType, CustomFilterOperator } from "../Shared/Models/CustomFilterModels";

export enum ConsultationsOrder {
    None,
    LegalCode,
    ConsultationStartDate,
    CaseName,
    ConsultationRespondBy
}

export class ConsultationsCustomFilterFields {
    static Fields: Array<CustomFilterField> = [
        { fieldName: "Status", fieldType: CustomFilterType.String, operators: [CustomFilterOperator.Equals] },
        { fieldName: "OrderTypeCode", fieldType: CustomFilterType.String, operators: [CustomFilterOperator.Equals] },
        { fieldName: "Postcode", fieldType: CustomFilterType.String, operators: [CustomFilterOperator.Contains] },
        { fieldName: "AdminAreaList", fieldType: CustomFilterType.String, operators: [CustomFilterOperator.Contains] },
        { fieldName: "ApplicantList", fieldType: CustomFilterType.String, operators: [CustomFilterOperator.Contains] },
        { fieldName: "Location", fieldType: CustomFilterType.String, operators: [CustomFilterOperator.Contains] },
        { fieldName: "Ref", fieldType: CustomFilterType.String, operators: [CustomFilterOperator.Contains] }
    ];
}
